class VideoPlayer {
  constructor(wndNo, playerType, isVideoPlayer, isRealPlay) {
    this.src = ""; //播放地址
    this.wndNo = wndNo; //窗口编号
    this.playerType = playerType;
    this.isVideoPlayer = isVideoPlayer; //是否是视频播放
    this.isRealPlay = isRealPlay || 0; //是否实时播放
    this.videoId =
      this.isRealPlay == 0 ? `video_${wndNo}` : `video_replay_${wndNo}`; //video元素的id
    this.canvasId =
      this.isRealPlay == 0 ? `canvasId_${wndNo}` : `canvasId_replay_${wndNo}`; //video元素的id

    this.prompt = ""; //各种提示内容
    this.VideoPlay = null; //播放的组件对象
    this.videoStatus = 0; //视频状态 0 未播放 1 等待中 2 播放中  前面内容还未确认
    this.displayName = null; //显示的标题，比如车牌
    this.iChannelId = null; //通道
    this.displayChannel = null; //通道显示，比如通道1 或者 司机位置
    this.flow = null;
    this.rotate = 0;
    this.totalTimeStamp = 0;
    this.historyTime = 0;
    this.codingFormat = 0; //视频编码
    this.reconnecting = false; //是否正在重连
    this.isShow = true; //是否显示
    this.wndClassName = "";
    this.simNum = "";
    this.plateNum = "";
    this.muteOrVoice = "mute_black"; //声音开关
    this.audioPlayer = null;
    this.recordStatus = 0; //录制状态 0 未录制 1 正在录制 2 录制完成
    this.recordStopThread = null;
    this.delay = 10;
    this.selectWndStyle = "";
    this.sessionid = ""; //sessionid 雅迅服务器的sessionid
    this.serverip = ""; //服务器ip，要发送给终端的
    this.tcpport = 0; //服务器端口，要发送给终端的
  }
  _generateConnectionUrl(simNum, channelId, serverip, tcpport) {
    //需要知道总共的数量
    console.log("获取播放地址" + simNum);
    var p = parseInt(this.wndNo / 6);
    var url_domain = "https://live" + (3 + p) + ".kingwings.cn";
    if (this.isRealPlay === 1) {
      //回放的地址不一样
      url_domain = "https://replay" + (3 + p) + ".kingwings.cn";
      // url_domain="http://172.20.8.3:33331/"
    }
    // url_domain = "wss://www.kingwings.cn:7205";
    //return url_domain + "/live/00140401000001.live.flv";
    console.log("服务ip", serverip);
    if (serverip == "106.12.137.238" || serverip == "182.61.34.145") {
      //要支持ws服务，不然要判断http请求的地址
      // return "https://www.kingwings.cn:7205/live/test.live.flv";
      return `${url_domain}/live/${simNum}-${channelId}`;
    } else {
      //雅迅的视频服务,todo 要确认这个地址是否正确 http://ws.kingwings.cn/live/003812008483_01.flv
      return `https://ws.kingwings.cn/live/${simNum}_0${channelId}.flv`;
      // return `https://live1.kingwings.cn:7210/live/${simNum}-0${channelId}.flv`;
    }
    //live1.kingwings.cn:7210
    // url = "https://live3.kingwings.cn/live/004010005821-1";
    // return "wss://www.kingwings.cn:7205/live/" + simNum + ".live.flv";
    // return "https://www.kingwings.cn:7205/live/" + simNum + ".live.flv";
  }
  // 开始录像，callback 录像结果反馈
  startRecord(callback) {
    if (callback && typeof callback === "function") {
      this.recordCallback = callback;
    }
    if (this.recordStatus > 0) {
      return this.recordStatus;
    }
    if (this.videoStatus !== 2) {
      return this.recordStatus;
    }
    //发送请求录制
    // const data = {
    //     action: "startrecordreq",
    //     id: this.playerId,
    //     orderid: this._getOrderId(),
    //     simnum: this.simNum,
    //     ch: this.iChannelId,
    //     data: {
    //         recordtype: 1
    //     }
    // };
    this.setPromptWord("empty");
    this.recordStatus = 1;
    this.VideoPlay.startRecord();
    // this.audioCtrl(1);
    // this.VideoPlay.send(JSON.stringify(data));
    return this.recordStatus;
  }

  getPaused() {
    return this.VideoPlay.getPaused();
  }

  pause() {
    this.VideoPlay.pause();
  }

  play() {
    this.VideoPlay.play();
  }

  stopRecord() {
    if (this.recordStatus === 0) {
      return this.recordStatus;
    }
    if (this.videoStatus !== 2) {
      this.recordStatus = 0;
      return this.recordStatus;
    }

    this.setPromptWord("stoprecording");
    this.recordStatus = 3;
    if (this.recordStopThread === null) {
      const self = this;
      this.recordStopThread = setTimeout(() => {
        self.recordStopThread = null;
        console.log("stopRecordTimeout", self.recordStatus);
        if (self.recordStatus === 3) {
          self.recordStatus = 0;
          self.setPromptWord("recodefailed");
          // self.playerEvent.onStopRecord({
          //     simNum: self.simNum,
          //     channelId: self.iChannelId,
          //     result: 2
          // });
        }
      }, 20000);
      // this.audioCtrl(0);
      this.VideoPlay.stopRecord();
      // this.VideoPlay.send(JSON.stringify(data));
    }
    return this.recordStatus;
  }
  // 停止播放
  stop(clearPrompt = true) {
    if (clearPrompt) {
      this.setPromptWord("empty");
    }
    if (this.recordStatus > 0 && this.stopRecord() === 3) {
      if (clearPrompt) {
        this.setPromptWord("waitrecordresult");
      }
      return false;
    }
    this.closeAudio();
    if (this.videoStatus === 1 || this.videoStatus === 2) {
      this.videoStatus = 3;
      if (this.playerType === "hv") {
        this.playStyle = "";
      } else {
        this.playStyle = "playBlock";
      }
      this.muteOrVoice = "mute_black";
      this._empty();
      this.totalReceivedBytes += this.receivedBytes;
      this.receivedBytes = 0;

      this.totalReceivedBytes = 0;
      this.totalTimeStamp = 0;
      this.codingFormat = 0;
    }
    return true;
  }
  // 清除内容
  clearContent() {
    if (this.stop(true) && this.videoStatus === 3) {
      this.plateNum = "";
      this.simNum = "";
      this.iChannelId = 0;
      this.videoStatus = 0;
      this.displayName = "";
      this.playStyle = "";
      this.reqBitStreamType = 1;
    }
  }
  // 清空内容
  _empty() {
    this.flow = "";
    this.lon = "";
    this.lat = "";
    this.tmTime = "";
    this.speed = "";
    if (this.isVideoPlayer) {
      this.VideoPlay.destroy();
      // this.videoplayBg = this.brightBg;
      this.isContinue = "isContinueHide";
    }
  }
  // 关闭音频
  closeAudio() {
    if (
      this.audioPlayer.audioStatus === 1 &&
      this.simNum === this.audioPlayer.simNum &&
      this.iChannelId === this.audioPlayer.iChannelId
    ) {
      this.muteOrVoice = "mute_black";
      this.VideoPlay.muted(); //通过video本身的属性实现
      this.audioPlayer.muted();
    }
  }
  // 打开音频
  openAudio() {
    this.muteOrVoice = "voice_black";

    this.audioPlayer.voice(this.simNum, this.iChannelId);

    this.VideoPlay.voice();
  }
  // 获取媒体信息
  getMediaInfo() {
    return this.videoStatus === 2 ? this.VideoPlay.getMediaInfo() : null;
  }
  setPromptWord(key) {
    //设置提示信息
    var e;
    e = this.isVideoPlayer ? "视频" : "音频";

    switch (key) {
      case "confirmConn":
        this.prompt = "连接中...";
        break;
      case "setWait":
        this.prompt = "正在请求".concat(e, "...");
        break;
      case "empty":
        this.prompt = "";

        break;
      case "connSuccess":
        this.prompt = "连接成功";
        // this.loadVideo();
        break;
      case "reconnect":
        this.prompt = "正在重连...";
        break;
      case "notSupport":
        this.prompt = "浏览器不支持".concat(e, "播放");
        break;
      case "reqVideo":
        this.prompt = "请求播放".concat(e, "...");
        break;
      case "noOps":
        this.prompt = "长时间未操作，已停止播放";
        break;
      case "noStream":
        this.prompt = "长时间无数据，已停止播放";
        break;
      case "stoprecording":
        this.prompt = "正在停止录像...";
        break;
      case "waitrecordresult":
        this.prompt = "正在等待录像结果,请稍后...";
        break;
      case "recodefailed":
        this.prompt = "录像失败";
        break;
      default:
        this.prompt = key; //直接传递中文进来
        break;
    }
    // this.prompt = key;
    return this.prompt;
  }
  setWait(simNum, channelId, plateNum) {
    console.log("setWait");
    this.simNum = simNum; //终端编码
    this.iChannelId = channelId;
    this.plateNum = plateNum;
    this.videoStatus = 1;
    this.displayName = plateNum;
    this.displayChannel = "通道" + channelId;
    if (this.videoStatus !== 1 && this.videoStatus !== 2) {
      this.setPromptWord("setWait");
    }
  }
  // 重连
  reconnect() {
    console.log("reconnect");
    // const status = this.videoStatus;
    // if (status === 1 || status === 2) {
    //     if (this.extParam && this.extParam.sendCmdType === 1) {
    //         this.reconnecting = true;
    //         console.log("Video：onPlayVideoReq请求重连...");
    //         const reqData = `{"sim":"${this.simNum}","ch":"${this.iChannelId}","avtype":"${this.reqAvType}","bitstreamtype":"${this.reqBitStreamType}"}`;
    //         this.setPromptWord("reconnect");
    //         this.playerEvent.onPlayVideoReq(reqData);
    //     } else {
    //         console.log("Video：正在重连...");
    //         this.setPromptWord("reconnect");
    //         this.VideoPlay.load();
    //     }
    // }
  }
  loadVideo() {
    console.log("loadVideo");//改为应答之后加载
    this.VideoPlay.load();
  }
  confirmConn(sessionid, serverip, tcpport, isRealPlay) {
    console.log("ConfirmConn2");
    this.sessionid = sessionid;
    this.serverip = serverip;
    this.tcpport = tcpport;
    this.isRealPlay = isRealPlay; //是否实时播放 0 表示实时播放 1表示历史回放
    if (this.videoStatus !== 2 || this.reconnecting) {
      this.videoStatus = 2;
      if (this.reconnecting) {
        this.reconnecting = false;
      }
      if (this.isVideoPlayer) {
        this.playStyle = "";
        this.lastStreamTime = new Date().getTime();
        // const protocol = window.location.protocol === "https:" ? "wss" : "ws";
        this.src = this._generateConnectionUrl(
          this.simNum,
          this.iChannelId,
          this.serverip,
          this.tcpport
        );
        // this.videoplayBg = this.darkBg;
        this.setPromptWord("confirmConn");
        this.VideoPlay.load();
      } else {
        // this.setPromptWord("confirmConn");
        // this.openAudio();
      }
    }
    //  else if (this._needSwitchStream) {
    //     this._needSwitchStream = false;
    //     this.switchStream();
    // }
  }
  // 统计信息
  onStatisticsInfo(info) {
    // console.log("onStatisticsInfo", info);
    // if (this.videoStatus === 2) {
    //     if (this.receivedBytes < info.receivedBytes) {
    //         this.lastStreamTime = new Date().getTime();
    //     }
    //     this.flow = info.speed.toFixed(1) + "KB/s";
    //     this.receivedBytes = info.receivedBytes;
    // }
  }
  onLoaded() {
    //视频内容加载完成

    console.log("onLoaded");
    if (this.isVideoPlayer) {
      this.flow = "0.0KB/s";
      console.log("websocket loaded", this.src);
      this.setPromptWord("connSuccess");
      //   if (this.receivedBytes > 0) {
      //     this.totalReceivedBytes += this.receivedBytes;
      //     this.receivedBytes = 0;
      //   }
    } else if (this.playerType === "ls") {
      this.setPromptWord("connSuccess");
    }
  }
  // 接收消息
  onReceiveMsg(message) {
    console.log("onReceiveMsg", message);
    // try {
    //     const data = JSON.parse(message);
    //     switch (data.action) {
    //         case "closestream":
    //             this.onClosestream(data);
    //             if (this.recordCallback) {
    //                 this.recordCallback(data);
    //             }
    //             break;
    //         case "startrecordrsp":
    //             this.onStartRecordRsp(data);
    //             break;
    //         case "stoprecordrsp":
    //             this.onStopRecordRsp(data);
    //             break;
    //         case "switchstream":
    //             this.onSwitchStream(data);
    //             break;
    //         default:
    //             console.log("未知消息类型:", data.action);
    //     }
    // } catch (error) {
    //     console.error("Error parsing message:", error);
    // }
  }
}

export default VideoPlayer;
